export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./InstitutionPanel.vue?vue&type=template&id=a656eb66&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/party/InstitutionPanel.vue?vue&type=template&id=a656eb66&scoped=true&
// module id = 1476
// module chunks = 0